<ap-dynforms [fieldsets]="formConfig" (apSubmit)="onSubmit()">
  <div dynforms.after>
    <div style="display: flex; padding-top: 8px">
      <div style="float: left; width: 40%">
        <button kendoButton [primary]="true" [routerLink]="[ApMenuUrls.LOGIN]"
                id="buttonBackToRegistration"
                class="k-button k-primary button-important">
          {{'Admin_Pages_Back_To_Registration' | translateAsync | async}}
        </button>
      </div>
      <div style="width: 20%"></div>
      <div style="float: right; width: 40%; text-align: right">
        <button [disabled]="!dynForm || !dynForm.form || !dynForm.form.valid || (loginLoading$ | async)"
                [icon] = "(passwordLoading$ | async) ? 'loading' : undefined"
                id="passwordRequest"
                class="k-button k-primary button-important"
                autofocus type="submit"
                style="width: 125px"
                [innerText]="(passwordLoading$ | async) ? '' : 'PwRequest_Request' | translateAsync | async"
                kendoButton [primary]="true">
        </button>
      </div>
    </div>
  </div>
</ap-dynforms>
